import GoTrue from 'gotrue-js';

const auth = new GoTrue({
    APIUrl: 'https://www.thealchemist.film/.netlify/identity',
    audience: '',
    setCookie: true
});

export default auth;
